<template>
<div class="content">
  <iframe allowfullscreen="true" ref="ifrm" width="100%" height="100%" :src='url'></iframe>
</div>
</template>

<script>


export default {
  data() {
    return {
      url: 'https://720yun.com/t/4dvkcyrwOpm?scene_id=62575405'
    };
  },

  mounted() {
  }
};
</script>

<style lang="less" scoped>

  .content{
    width: 100%;
    height: 100%;
    margin-top: 20px;
    display: flex;

    iframe {
      display: block; /* iframes are inline by default */
      background: #000;
      border: none; /* Reset default border */
      height: 70vh; /* Viewport-relative units */
      /*width: 96vw;*/
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exhibitionHall/VRShow/index.vue